module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_RU.fa954b56.txt";